import { Pipe, PipeTransform, inject } from '@angular/core';

import { AuthService } from '@plugins/client/auth';

@Pipe({
  name: 'isAuthor',
})
export class IsAuthorPipe implements PipeTransform {
  private readonly authService = inject(AuthService);

  transform(id?: string): boolean {
    if (!id) return false;
    return this.authService.userToken.sub === id;
  }
}
